import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import store from './store'
import VueResource from 'vue-resource'
import VTooltip from 'v-tooltip'

import '@/assets/style/global.scss'

import { localization } from './plugins/localization'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlay, faStop, faFileExcel, faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import JsonExcel from 'vue-json-excel'

import Dom from '@/Modules/Dom'


import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
// Init plugin
Vue.use(Loading)

// console.log('dom', dom.waitForElm('.category-seaction').then((elm) => console.log('elm', elm)))

const columnes = [
  'year',
  'global_rank_ease_of_doing_bussiness',
  'starting_a_business',
  'registering_property',
  'paying_taxes',
  'db_score',
  'global_competitiveness_rank',
  'hdi_rank',
  'hdi'
]

Vue.filter('num', (value, isYear = false) => {
  if (columnes.includes(isYear)) return value
  if (!value) return ''
  // const val = (value / 1).toFixed(1).replace('.', ',')
  return value.toLocaleString('ru-RU', { minimumFractionDigits: 1 }).replace(',', '.') // val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
})

library.add([faPlay, faStop, faFileExcel, faArrowDown, faArrowUp])
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('downloadExcel', JsonExcel)

Vue.component('spiner', () => import(
  /* webpackChunkName: "components/spiner/spiner" */
  '@/components/Spiner/Spiner'
))

Vue.use(VueResource)
Vue.use(VTooltip)

Vue.config.productionTip = false

const $i18nRoute = Vue.prototype.$i18nRoute = localization.i18nRoute.bind(localization)
window.eventBus = Vue.prototype.$eventBus = new Vue()

Vue.http.interceptors.push(function (request) {

  // request.headers.set('Content-Type', 'application/x-www-form-urlencoded')
  // request.headers.set('Access-Control-Allow-Origin', '*')
  // request.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'))

  return function (response) {

    // response.headers.set('Access-Control-Allow-Origin', '*')

  	if (response.status === 401) {}
    
  }
})

router.beforeEach((to, from, next) => {
  store.commit('set_route', to)
  store.commit('set_router', router)

  if (from.name && to.name !== from.name && to.params.locale !== from.params.locale) {
    
    const redirect = router.resolve($i18nRoute({ 
      name: to.name, 
      params: to.params, 
      query: to.query 
    }))

    router.replace({ path: redirect.route.fullPath.replace(/^(.+?)\/*?$/, '$1') }).catch(() => {})
    // store.dispatch('localStorage/fetch').then(() => next())
    // next()
    return
  }

  if (!store.getters['localStorage/hasStatus']()) {
  	store.dispatch('localStorage/fetch').then(() => next())
  	return false
  } 

  next()
})

router.afterEach((to, from) => {
  // const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
  // const category = document.querySelector('.category-seaction')
  // const tableThs = document.querySelectorAll('.responstable th')
  // if (!category) {
  //   return 
  // }
  // if (currentScrollPosition > 0) {
  //   category.style.top = document.getElementById('main-menu').clientHeight + 'px';
  //   // category.style.boxShadow = '0 5px 5px rgb(0 0 0 / 5%)';
  //   [...tableThs].map((elm, index) => {
  //     elm.style.top = ((document.getElementById('main-menu').clientHeight + category.clientHeight) - 2) + 'px'
  //     // elm.style.boxShadow = '0 5px 5px rgb(0 0 0 / 5%)'
  //   })
  // } else {
  //   category.removeAttribute('style');
  //   [...tableThs].map((elm, index) => {
  //     elm.removeAttribute('style')
  //   })
  // }
})

const dom = Dom.getInstance()
dom.Ready()

window.vue = new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
